import { Drawer } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { useCommonContext, usePurchaseHistoryContext, } from '../../../../hooks/useContexts';
import { InStoreReceiptForm, OnlineReceiptForm, ReceiptScanner, SelectReceiptType, } from './index';
export var AddReceiptDrawer = function (_a) {
    var closeDrawer = _a.closeDrawer, isDrawerOpen = _a.isDrawerOpen, _b = _a.svocId, svocId = _b === void 0 ? '' : _b;
    var isMobile = useCommonContext().isMobile;
    var setAlertState = usePurchaseHistoryContext().setAlertState;
    var mobileView = isMobile ? 0 : 1;
    var _c = useState(mobileView), drawerStepper = _c[0], setDrawerStepper = _c[1];
    var closeReceiptDrawer = function () {
        closeDrawer();
        setTimeout(function () {
            setDrawerStepper(mobileView);
        }, 500);
    };
    var generateReceiptType = function () {
        switch (drawerStepper) {
            case 0:
            case 1:
                return (React.createElement(SelectReceiptType, { closeDrawer: closeReceiptDrawer, drawerStepper: drawerStepper, setDrawerStepper: setDrawerStepper }));
            case 2:
                return (React.createElement(InStoreReceiptForm, { closeDrawer: closeReceiptDrawer, setAlertState: setAlertState, svocId: svocId }));
            case 3:
                return (React.createElement(OnlineReceiptForm, { closeDrawer: closeReceiptDrawer, setAlertState: setAlertState, svocId: svocId }));
            case 4:
                return (React.createElement(ReceiptScanner, { closeDrawer: closeReceiptDrawer, setAlertState: setAlertState, setDrawerStepper: setDrawerStepper, svocId: svocId }));
            default:
                break;
        }
        return null;
    };
    return (React.createElement(Drawer, { open: isDrawerOpen, onClose: closeReceiptDrawer, style: { zIndex: 2000000008 } }, generateReceiptType()));
};
